<template>
    <div class="after-sales-orders">
        <van-nav-bar title="售后工单" left-arrow @click-left="$router.back()">
            <template #right><van-icon name="replay" @click="loadOrders" /></template>
        </van-nav-bar>
        <main class="orders-content">
            <van-search v-model="deviceSn" placeholder="输入设备 SN 查询" shape="round" @search="loadOrders" />
            <div class="status-tabs">
                <button v-for="tab in tabs" :key="tab.value" type="button" :class="{ active: status === tab.value }" @click="changeStatus(tab.value)">{{ tab.label }}</button>
            </div>
            <div v-if="loading" class="list-state"><van-loading size="28" vertical>正在加载售后工单</van-loading></div>
            <div v-else-if="!orders.length" class="list-state"><van-icon name="orders-o" size="44" /><strong>暂无内部售后工单</strong><span>接件创建工单后，会在这里继续处理</span></div>
            <template v-else>
                <button v-for="item in orders" :key="item.id" type="button" class="order-card" @click="openWorkflow(item)">
                    <div class="order-head"><span class="order-no">{{ item.order_no }}</span><van-tag :type="item.work_status === 'completed' ? 'success' : 'primary'">{{ stageText(item.current_stage) }}</van-tag></div>
                    <h3>{{ item.product_name || item.product_model || '售后设备' }}</h3>
                    <p>{{ item.issue_type }}：{{ item.description }}</p>
                    <div class="order-meta"><span>SN {{ item.internal_sn }}</span><span>{{ formatTime(item.update_time || item.create_time) }}</span></div>
                    <div class="order-action">继续处理 <van-icon name="arrow" /></div>
                </button>
            </template>
        </main>
    </div>
</template>

<script>
import afterSalesApi from '@/api/after_sales_internal_api.js'

const responsePayload = response => response && (response.other || response.data || response.result)

export default {
    name: 'AfterSalesOrdersMobile',
    data() {
        return {
            loading: false,
            deviceSn: '',
            status: 'active',
            page: 1,
            orders: [],
            tabs: [
                { label: '待处理', value: 'active' },
                { label: '已完成', value: 'completed' },
                { label: '全部', value: '' }
            ]
        }
    },
    computed: {
        appId() { return this.$root.app_id || '' }
    },
    mounted() {
        document.title = '售后工单'
        this.loadOrders()
    },
    methods: {
        async loadOrders() {
            this.loading = true
            try {
                const response = await afterSalesApi.listWorkflow(this.appId, { status: this.status, device_sn: this.deviceSn.trim(), page: this.page, each_page: 30 })
                const payload = responsePayload(response)
                if (!response || response.errcode !== 0 || !payload) throw new Error((response && (response.errmsg || response.msg)) || '工单加载失败')
                this.orders = payload.list || []
            } catch (error) {
                this.$toast.fail(error.message || '工单加载失败')
            } finally {
                this.loading = false
            }
        },
        changeStatus(status) {
            this.status = status
            this.page = 1
            this.loadOrders()
        },
        openWorkflow(item) {
            this.$router.push({ name: 'after-sales-workflow', query: { order_id: item.order_id || item.id } })
        },
        stageText(stage) {
            const map = { received: '待确认', diagnosis_completed: '待维修', repairing: '维修中', qc_pending: '待质检', qc_failed: '待返修', qc_passed: '待处理', disposition: '处理中', waiting_ship: '待寄送', shipped: '已发货', signed: '已签收', closed: '已关闭' }
            return map[stage] || '处理中'
        },
        formatTime(value) {
            if (!value) return '-'
            const date = new Date(Number(value) * 1000)
            if (Number.isNaN(date.getTime())) return '-'
            const pad = n => String(n).padStart(2, '0')
            return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
        }
    }
}
</script>

<style scoped>
.after-sales-orders { width: 100%; height: 100%; min-height: 0; overflow-x: hidden; overflow-y: auto; -webkit-overflow-scrolling: touch; overscroll-behavior-y: contain; background: #f5f8fb; color: #1f2937; }
.orders-content { max-width: 760px; margin: 0 auto; padding: 10px 14px 36px; font-size: 18px; }
.status-tabs { display: flex; gap: 10px; padding: 10px 2px 14px; overflow-x: auto; }
.status-tabs button { flex: 0 0 auto; border: 0; border-radius: 22px; padding: 11px 22px; color: #64748b; background: #e8edf4; font-size: 18px; }
.status-tabs button.active { color: #fff; background: #315fe8; }
.list-state { display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 90px 0; color: #94a3b8; }
.list-state strong { color: #475569; font-size: 18px; }
.list-state span { font-size: 17px; }
.order-card { display: block; width: 100%; margin-bottom: 14px; padding: 16px; border: 0; border-radius: 16px; text-align: left; background: #fff; box-shadow: 0 5px 18px rgba(31,41,55,.06); }
.order-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.order-no { color: #315fe8; font: 600 17px/1.45 Consolas, monospace; word-break: break-all; }
.order-card h3 { margin: 16px 0 8px; font-size: 23px; }
.order-card p { margin: 0; color: #64748b; line-height: 1.65; font-size: 18px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.order-meta { display: flex; justify-content: space-between; gap: 12px; margin-top: 16px; color: #94a3b8; font-size: 16px; }
.order-meta span:first-child { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.order-action { display: flex; align-items: center; justify-content: flex-end; gap: 4px; margin-top: 14px; color: #315fe8; font-size: 18px; }
.after-sales-orders ::v-deep .van-nav-bar__title { font-size: 22px; font-weight: 600; }
.after-sales-orders ::v-deep .van-nav-bar__arrow,
.after-sales-orders ::v-deep .van-nav-bar__right .van-icon { font-size: 25px; }
.after-sales-orders ::v-deep .van-search__content { min-height: 48px; }
.after-sales-orders ::v-deep .van-field__control { font-size: 19px; }
.after-sales-orders ::v-deep .van-tag { padding: 4px 9px; font-size: 17px; line-height: 26px; }
.after-sales-orders ::v-deep .van-loading__text { font-size: 18px; }
</style>
